<template>
  <div>
    <b-sidebar
      :visible="visible"
      @hidden="noVisible"
      title="Search"
      backdrop-variant="dark"
      backdrop
    >
      <div class="px-3 py-2">
        <form @submit.prevent="submitSearch">
          <div class="row">
            <div class="col-12 grid-margin">
              <div
                class="form-group"
                v-for="(item, index) in data_fields"
                :key="index"
              >
                <span
                  v-if="
                    item[alias_table + '_f_input_type'] == 's_autocomplete' ||
                      item[alias_table + '_f_input_type'] == 'option' ||
                      item[alias_table + '_f_input_type'] == 'm_autocomplete'
                  "
                >
                  <label :for="item[alias_table + '_f_name']">{{
                    item[alias_table + "_f_label"]
                  }}</label>
                  <component
                    :is="item[alias_table + '_f_input_type'] + '_form'"
                    :name="item[alias_table + '_f_name']"
                    :table_module="table_module"
                    :content="getContent[item[alias_table + '_f_name']]"
                    :dropdown_name="item[alias_table + '_f_options']"
                    @post="bindingData"
                    :extraSearch="extraSearch[item[alias_table + '_f_name']]"
                    :search="true"
                  ></component>
                </span>
                <span
                  v-else-if="
                    item[alias_table + '_f_input_type'] != 'longtext' &&
                      item[alias_table + '_f_input_type'] != 'number'
                  "
                >
                  <label :for="item[alias_table + '_f_name']">{{
                    item[alias_table + "_f_label"]
                  }}</label>
                  <component
                    :is="item[alias_table + '_f_input_type'] + '_form'"
                    :name="item[alias_table + '_f_name']"
                    :table_module="table_module"
                    :content="getContent[item[alias_table + '_f_name']]"
                    :dropdown_name="item[alias_table + '_f_options']"
                    @post="bindingData"
                    :search="true"
                  ></component>
                </span>
                <div v-else>
                  <label :for="item[alias_table + '_f_name']">{{
                    item[alias_table + "_f_label"]
                  }}</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="dataSearch[item[alias_table + '_f_name']]"
                    :id="item[alias_table + '_f_name']"
                  />
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div class="d-flex align-items-center justify-content-start">
            <button type="submit" class="btn btn-primary mr-1">Search</button>
            <button
              class="btn btn-secondary mr-1"
              type="reset"
              @click="resetSearch()"
            >
              Reset
            </button>
          </div>
        </form>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import text_form from "@/components/input/text";
import longtext_form from "@/components/input/longtext";
import number_form from "@/components/input/number";
import option_form from "@/components/input/option";
import s_autocomplete_form from "@/components/input/single_autocomplete";
import m_autocomplete_form from "@/components/input/multiple_autocomplete";
import phone_form from "@/components/input/phone";
import time_form from "@/components/input/time";
import datetime_form from "@/components/input/datetime";
import money_form from "@/components/input/money";
import year_form from "@/components/input/year";
import radio_form from "@/components/input/radio";
import s_image_form from "@/components/input/s_image";
import email_form from "@/components/input/email";
import tag_form from "@/components/input/tags";
import date_form from "@/components/input/date";
import m_option_form from "@/components/input/m_option";

export default {
  props: {
    module: {
      type: String,
      required: true,
    },
    table_module: {
      type: String,
      required: true,
    },
    alias_table: {
      type: String,
      required: true,
    },
    visible: {
      type: Boolean,
      required: true,
    },
    fields: {
      type: [Array, Object],
      required: true,
    },
  },
  components: {
    text_form,
    longtext_form,
    number_form,
    option_form,
    s_autocomplete_form,
    phone_form,
    time_form,
    datetime_form,
    money_form,
    m_autocomplete_form,
    year_form,
    radio_form,
    s_image_form,
    email_form,
    tag_form,
    date_form,
    m_option_form
  },
  data() {
    return {
      dataSearch: {},
      getContent: {},
      extraSearch: [],
    };
  },
  computed: {
    data_fields() {
      var res = this.fields;

      res.forEach((element, key) => {
        if (
          element[this.alias_table + "_f_input_type"] == "editor" ||
          element[this.alias_table + "_f_input_type"] == "s_image" ||
          element[this.alias_table + "_f_input_type"] == "m_image"
        ) {
          res.splice(key, 1);
        }
      });

      return res;
    },
  },
  methods: {
    noVisible() {
      this.$emit("hiddenSideSearch");
    },
    submitSearch() {
      this.$emit("loading", true);
      let paramSearch = {};
      for (const key in this.dataSearch) {
        if (this.dataSearch[key] !== '' && this.dataSearch[key] != 0) 
        {
          paramSearch[key] = this.dataSearch[key];
        }
      }
      
      this.$emit("paramSearch", { search: paramSearch });
      this.$emit("hiddenSideSearch");
    },
    resetSearch() {
      this.dataSearch = {};
      this.getContent = {};
      this.extraSearch = [];
      this.submitSearch();
    },
    bindingData: function(value) {
      if (value["value"] == null || value["value"] === "") {
        // if (this.table_module == "services_bulk" && value["name"] == "srv_id") {
        //   this.$children.forEach((element, key) => {
        //     if (element.name == "srv_id") {
        //       this.$children[key].post = [];
        //       this.$children[key].extra = {};
        //       this.$children[key].list = {};
        //     }
        //   });
        // }
        this.$delete(this.dataSearch, value["name"]);
      } else {
        if (value.type != undefined) {
          var arx = {};
          if (value.type == "option") {
            arx = {
              dd_o_label: value.label,
              dd_o_value: value.value,
            };
            this.$set(this.getContent, value["name"], arx);
          } else if (value.type == "single_autocomplete") {
            arx = value.content;
            this.$set(this.extraSearch, value["name"], arx);
            this.$set(this.getContent, value["name"], arx);
          }
        }
        this.$set(this.dataSearch, value["name"], value["value"]);
        this.$set(this.getContent, value["name"], value["value"]);
      }
    },
  },
};
</script>
